import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'

export default {
  PublicRoute,
  PrivateRoute
}
